function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
// cspell:words QWILT EDGIO caas MEDIACDN
import { CoreVideoInternal } from '../../core-video-internal';
import { sdkLogger } from '../../logger';
import { TestingOverrides } from '../services/testing-overrides';
import { JsonUtils } from '../../utils/json-utils';
import { getPrioritizedCdns } from './meta-list-manager';
import { BitrateCapReason } from './meta-list-manager.enums';
export { BitrateCapReason } from './meta-list-manager.enums';
var KnownCdns = {
    LIMELIGHT: 'll',
    EDGIO: 'll',
    // note: Peacock uses the name LIMELIGHT for this CDN, but Showmax uses EDGIO
    FASTLY: 'fy',
    CLOUDFRONT: 'cf',
    AKAMAI: 'ak',
    COMCAST: 'cc',
    LEVEL3: 'cl',
    GOOGLE: 'mc',
    MEDIACDN: 'mc',
    QWILT: 'qw'
};
/**
     * Constructed URL for polling bitrate cap from CDN:
     * ${domainBase}${domainNumber}${domainMid}${domainProd || domainStage}${cdnAbbreviation}.${host}${CDN_URL_PATHNAME}
     */ var BITRATE_CAP_INSTRUCTIONS_DEFAULT_POLLING_TIMEOUT = 60000;
var LEGACY_CDN_URL_PATHNAME = '/caas/bitrate/cap-instructions.json';
// currently not used by CVSDK
// currently not used by CVSDK
var getStartingCaps = function() {
    var _CoreVideoInternal_playerCapabilities_maxBitrate;
    var _obj;
    return _obj = {}, _define_property(_obj, BitrateCapReason.UserConfiguredCap, Infinity), _define_property(_obj, BitrateCapReason.CoordinatedBitrateCap, Infinity), _define_property(_obj, BitrateCapReason.DeviceCapabilityCap, (_CoreVideoInternal_playerCapabilities_maxBitrate = CoreVideoInternal.playerCapabilities.maxBitrate) !== null && _CoreVideoInternal_playerCapabilities_maxBitrate !== void 0 ? _CoreVideoInternal_playerCapabilities_maxBitrate : Infinity), _define_property(_obj, BitrateCapReason.MobileNetworkThrottle, Infinity), _define_property(_obj, BitrateCapReason.SecurityEnforcedCap, Infinity), _obj;
};
export var getStartingMaxBitrate = function() {
    var requestedMaxBitRate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Infinity;
    var currentCaps = getStartingCaps();
    var maxBitRateData = getLowestBitrateCap(requestedMaxBitRate, BitrateCapReason.UserConfiguredCap, currentCaps);
    return maxBitRateData.value;
};
// Get the lowest value of all caps, taking into account the requested cap and all current caps, if any.
export var getLowestBitrateCap = function() {
    var requestedMaxBitRate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Infinity, requestReason = arguments.length > 1 ? arguments[1] : void 0, currentCaps = arguments.length > 2 ? arguments[2] : void 0, currentAppliedCap = arguments.length > 3 ? arguments[3] : void 0;
    var _Math;
    var currentCapChanged = false;
    var requestedCapChanged = false;
    var currentReason = requestReason;
    if (currentCaps[requestReason] !== requestedMaxBitRate) {
        requestedCapChanged = true;
    }
    currentCaps[requestReason] = requestedMaxBitRate;
    var lowestCap = (_Math = Math).min.apply(_Math, _to_consumable_array(Object.values(currentCaps)));
    for(var cap in currentCaps){
        if (currentCaps[cap] === lowestCap) {
            currentReason = cap;
            break;
        }
    }
    if (!currentAppliedCap || lowestCap !== currentAppliedCap) {
        currentCapChanged = true;
    }
    return {
        value: lowestCap,
        reason: currentReason,
        requestedCapChanged: requestedCapChanged,
        currentCapChanged: currentCapChanged
    };
};
export var BitrateCapManager = /*#__PURE__*/ function() {
    "use strict";
    function BitrateCapManager(bitrateCapObservables) {
        var _this = this;
        _class_call_check(this, BitrateCapManager);
        var _this1 = this;
        _define_property(this, "bitrateCapObservables", void 0);
        _define_property(this, "currentAppliedCap", void 0);
        _define_property(this, "currentCaps", void 0);
        _define_property(this, "handleApplyCap", void 0);
        /** @deprecated To be removed once legacy polling is removed. */ _define_property(this, "legacyPrimaryCdn", void 0);
        _define_property(this, "bitrateCapInstructionPollingTimeout", void 0);
        _define_property(this, "logger", void 0);
        _define_property(this, "getMaxBitRate", void 0);
        /*
     ** At each polling cycle:
     **     1) Fetch bitrate cap instruction config from CDNs
     **     2) Fire bitrate capping callback if needed
     **     3) Start polling timeout for next cycle based on new time-to-live
     */ _define_property(this, "legacyCapInstructionPollingCycleHandler", void 0);
        _define_property(this, "stopCapInstructionPolling", void 0);
        _define_property(this, "notifyRequestedBitrateCap", void 0);
        _define_property(this, "notifyAppliedBitrateCap", void 0);
        // update current cap for future comparisons
        _define_property(this, "destroy", void 0);
        this.bitrateCapObservables = bitrateCapObservables;
        this.currentCaps = getStartingCaps();
        this.bitrateCapInstructionPollingTimeout = undefined;
        this.logger = sdkLogger.withContext('BCM');
        this.getMaxBitRate = function(requestedMaxBitRate, requestReason) {
            return getLowestBitrateCap(requestedMaxBitRate, requestReason, _this.currentCaps, _this.currentAppliedCap);
        };
        this.legacyCapInstructionPollingCycleHandler = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(cdns, handleApplyCap, options) {
                var startIndex, _this, _TestingOverrides_coordinatedBitrateCap, capInstructionsTimeToLiveMs, i, currentIndex, currentCdn, cdnBitrateCapConfigUrl, cdnName, response, jsonResponse, _TestingOverrides_coordinatedBitrateCap1, _jsonResponse_capInstructions_cdnName, currentCdnCap, error;
                var _arguments = arguments;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            startIndex = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 0;
                            cdns = getPrioritizedCdns(_this1.legacyPrimaryCdn, cdns);
                            _this1.logger.verbose("Current bitrate caps: ".concat(JsonUtils.stringify((_this = _this1) === null || _this === void 0 ? void 0 : _this.currentCaps)));
                            if ((_TestingOverrides_coordinatedBitrateCap = TestingOverrides.coordinatedBitrateCap) === null || _TestingOverrides_coordinatedBitrateCap === void 0 ? void 0 : _TestingOverrides_coordinatedBitrateCap.pollingTimeout) {
                                capInstructionsTimeToLiveMs = TestingOverrides.coordinatedBitrateCap.pollingTimeout;
                            }
                            i = 0;
                            _state.label = 1;
                        case 1:
                            if (!(i < cdns.length)) return [
                                3,
                                7
                            ];
                            _state.label = 2;
                        case 2:
                            _state.trys.push([
                                2,
                                5,
                                ,
                                6
                            ]);
                            // Do this to start in middle of array and loop back to beginning if necessary
                            currentIndex = (i + startIndex) % cdns.length;
                            currentCdn = cdns[currentIndex];
                            cdnBitrateCapConfigUrl = _this1.legacyGetRequestUrl(currentCdn);
                            if (!cdnBitrateCapConfigUrl) {
                                return [
                                    3,
                                    6
                                ];
                            }
                            cdnName = currentCdn.name;
                            return [
                                4,
                                fetch(cdnBitrateCapConfigUrl, options)
                            ];
                        case 3:
                            response = _state.sent();
                            if (!response.ok) {
                                _this1.logger.warn("Error in bitrate cap instructions response: ".concat(response.statusText));
                                return [
                                    3,
                                    6
                                ];
                            }
                            return [
                                4,
                                response.json()
                            ];
                        case 4:
                            jsonResponse = _state.sent();
                            if (jsonResponse && jsonResponse.capInstructions) {
                                ;
                                // Only set if we aren't using testing overrides
                                if (!capInstructionsTimeToLiveMs) {
                                    capInstructionsTimeToLiveMs = jsonResponse.timeToLiveSeconds * 1000;
                                }
                                if ((_TestingOverrides_coordinatedBitrateCap1 = TestingOverrides.coordinatedBitrateCap) === null || _TestingOverrides_coordinatedBitrateCap1 === void 0 ? void 0 : _TestingOverrides_coordinatedBitrateCap1.bitrateCap) {
                                    jsonResponse.capInstructions[cdnName] = TestingOverrides.coordinatedBitrateCap.bitrateCap !== Infinity ? TestingOverrides.coordinatedBitrateCap.bitrateCap : null;
                                }
                                ;
                                currentCdnCap = (_jsonResponse_capInstructions_cdnName = jsonResponse.capInstructions[cdnName]) !== null && _jsonResponse_capInstructions_cdnName !== void 0 ? _jsonResponse_capInstructions_cdnName : Infinity;
                                if (currentCdnCap !== _this1.currentCaps[BitrateCapReason.CoordinatedBitrateCap]) {
                                    handleApplyCap({
                                        maxBitRate: currentCdnCap !== null && currentCdnCap !== void 0 ? currentCdnCap : Infinity
                                    }, BitrateCapReason.CoordinatedBitrateCap);
                                } else {
                                    _this1.logger.verbose('Coordinated bitrate cap has not changed.');
                                }
                                startIndex = currentIndex;
                                // Only get the first successful response
                                return [
                                    3,
                                    7
                                ];
                            }
                            return [
                                3,
                                6
                            ];
                        case 5:
                            error = _state.sent();
                            _this1.logger.warn("Error fetching bitrate cap instructions: ".concat(JsonUtils.stringify(error)));
                            return [
                                3,
                                6
                            ];
                        case 6:
                            i++;
                            return [
                                3,
                                1
                            ];
                        case 7:
                            if (i === cdns.length) {
                                // If we reach here, we didn't break the loop
                                // i.e. all of the requests failed
                                startIndex = 0;
                            }
                            _this1.stopCapInstructionPolling();
                            // Regardless of failure or success, set new timeout
                            _this1.bitrateCapInstructionPollingTimeout = setTimeout(function() {
                                _this1.legacyCapInstructionPollingCycleHandler(cdns, handleApplyCap, options, startIndex);
                            }, capInstructionsTimeToLiveMs !== null && capInstructionsTimeToLiveMs !== void 0 ? capInstructionsTimeToLiveMs : BITRATE_CAP_INSTRUCTIONS_DEFAULT_POLLING_TIMEOUT);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(cdns, handleApplyCap, options) {
                return _ref.apply(this, arguments);
            };
        }();
        this.stopCapInstructionPolling = function() {
            clearTimeout(_this.bitrateCapInstructionPollingTimeout);
            _this.bitrateCapInstructionPollingTimeout = undefined;
        };
        this.notifyRequestedBitrateCap = function(requestedBitrateCapData) {
            _this.logger.verbose("Notifying requested bitrate cap - value: ".concat(requestedBitrateCapData.value, "; reason: ").concat(requestedBitrateCapData.reason));
            _this.bitrateCapObservables.bitrateCapRequestedObservable.notifyObservers({
                value: requestedBitrateCapData.value,
                reason: requestedBitrateCapData.reason
            });
        };
        this.notifyAppliedBitrateCap = function(appliedBitrateCapData) {
            _this.logger.verbose("Notifying applied bitrate cap - value: ".concat(appliedBitrateCapData.value, "; reason: ").concat(appliedBitrateCapData.reason));
            _this.bitrateCapObservables.bitrateCapChangedObservable.notifyObservers({
                value: appliedBitrateCapData.value,
                reason: appliedBitrateCapData.reason
            });
            _this.currentAppliedCap = appliedBitrateCapData.value;
        };
        this.destroy = function() {
            _this.stopCapInstructionPolling();
        };
    }
    _create_class(BitrateCapManager, [
        {
            key: "start",
            value: function start(handleApplyCap, metaListManager, cdns, options) {
                var startIndex = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
                this.handleApplyCap = handleApplyCap;
                metaListManager.registerCallBack(this.handleResponse.bind(this));
                metaListManager.handleStartPooling(cdns, options, startIndex);
            }
        },
        {
            key: "setLegacyPrimaryCdn",
            value: /** @deprecated To be removed once legacy polling is removed. */ function setLegacyPrimaryCdn(cdn) {
                this.legacyPrimaryCdn = cdn;
            }
        },
        {
            key: "legacyGetRequestUrl",
            value: function legacyGetRequestUrl(currentCdn) {
                var _CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping, _CoreVideoInternal_getPropositionExtensions, _cdnUrl_match;
                var cdnAbbreviation = KnownCdns[currentCdn.name];
                var cappingUrlData = (_CoreVideoInternal_getPropositionExtensions = CoreVideoInternal.getPropositionExtensions()) === null || _CoreVideoInternal_getPropositionExtensions === void 0 ? void 0 : (_CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping = _CoreVideoInternal_getPropositionExtensions.coordinatedBitrateCapping) === null || _CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping === void 0 ? void 0 : _CoreVideoInternal_getPropositionExtensions_coordinatedBitrateCapping.urlPieces;
                if (!cappingUrlData || !cdnAbbreviation) {
                    return '';
                }
                var _currentCdn_originalUrl;
                var cdnUrl = (_currentCdn_originalUrl = currentCdn.originalUrl) !== null && _currentCdn_originalUrl !== void 0 ? _currentCdn_originalUrl : currentCdn.url;
                // prod uses both original url and url, stable-int has only url
                var domainBase = cappingUrlData.domainBase, domainMid = cappingUrlData.domainMid, domainProd = cappingUrlData.domainProd, domainStage = cappingUrlData.domainStage, host = cappingUrlData.host;
                var _cdnUrl_match_;
                var domainNumber = (_cdnUrl_match_ = (_cdnUrl_match = cdnUrl.match('^https://[a-z][0-9][0-9]([0-9])')) === null || _cdnUrl_match === void 0 ? void 0 : _cdnUrl_match[1]) !== null && _cdnUrl_match_ !== void 0 ? _cdnUrl_match_ : '1';
                var domainPrdOrStg = cdnUrl.slice(0, cdnUrl.indexOf(host)).includes(domainStage) ? domainStage : domainProd;
                return "".concat(domainBase).concat(domainNumber).concat(domainMid).concat(domainPrdOrStg).concat(cdnAbbreviation, ".").concat(host).concat(LEGACY_CDN_URL_PATHNAME);
            }
        },
        {
            key: "handleResponse",
            value: function handleResponse(jsonResponse, cdnName) {
                var _this, _jsonResponse_globalConfigs;
                this.logger.verbose("Current bitrate caps: ".concat(JsonUtils.stringify((_this = this) === null || _this === void 0 ? void 0 : _this.currentCaps)));
                var jsonResponseInstructions = (_jsonResponse_globalConfigs = jsonResponse.globalConfigs) === null || _jsonResponse_globalConfigs === void 0 ? void 0 : _jsonResponse_globalConfigs.capInstructions;
                if (jsonResponseInstructions) {
                    // Only set if we aren't using testing overrides
                    var coordinatedBitrateCap = TestingOverrides.coordinatedBitrateCap;
                    if (coordinatedBitrateCap === null || coordinatedBitrateCap === void 0 ? void 0 : coordinatedBitrateCap.bitrateCap) {
                        jsonResponseInstructions[cdnName] = coordinatedBitrateCap.bitrateCap !== Infinity ? coordinatedBitrateCap.bitrateCap : null;
                    }
                    var _jsonResponseInstructions_cdnName;
                    var currentCdnCap = (_jsonResponseInstructions_cdnName = jsonResponseInstructions[cdnName]) !== null && _jsonResponseInstructions_cdnName !== void 0 ? _jsonResponseInstructions_cdnName : Infinity;
                    if (currentCdnCap !== this.currentCaps[BitrateCapReason.CoordinatedBitrateCap] && this.handleApplyCap) {
                        this.handleApplyCap({
                            maxBitRate: currentCdnCap !== null && currentCdnCap !== void 0 ? currentCdnCap : Infinity
                        }, BitrateCapReason.CoordinatedBitrateCap);
                    } else {
                        this.logger.verbose('Coordinated bitrate cap has not changed.');
                    }
                    return true;
                }
                return false;
            }
        }
    ]);
    return BitrateCapManager;
}();

//# sourceMappingURL=bitrate-cap-manager.js.map